import { useState, useEffect } from "react";
import { api } from "../lib/api";
import { HeartStraight } from "@phosphor-icons/react";

const BUCKET_META = {
  strong: { label: "strong", color: "#34C759" },
  healthy: { label: "healthy", color: "var(--accent)" },
  needs_attention: { label: "needs attention", color: "#FF9500" },
  dormant: { label: "dormant", color: "#8E8E93" },
};

export default function RelationshipScore({ contactId, compact = false }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!contactId) return;
    const run = async () => {
      try {
        const r = await api.get(`/ai/contacts/${contactId}/score`);
        setData(r.data);
      } catch (e) {
        setData(null);
      }
    };
    run();
  }, [contactId]);

  if (!data) return null;
  const meta = BUCKET_META[data.bucket] || BUCKET_META.needs_attention;

  if (compact) {
    return (
      <span
        className="tag flex items-center gap-1"
        style={{ color: meta.color, borderColor: meta.color }}
        data-testid="relationship-score-chip"
        title={`Relationship score ${data.score}/100 (${meta.label})`}
      >
        <HeartStraight weight="fill" /> {data.score}
      </span>
    );
  }

  return (
    <div className="border p-4" style={{ borderColor: "var(--border)" }} data-testid="relationship-score">
      <div className="flex items-center justify-between">
        <div className="overline flex items-center gap-2">
          <HeartStraight weight="bold" style={{ color: meta.color }} /> // relationship
        </div>
        <span className="tag" style={{ color: meta.color, borderColor: meta.color }} data-testid="relationship-bucket">
          {meta.label}
        </span>
      </div>
      <div className="mt-3 flex items-baseline gap-2">
        <div className="text-3xl font-bold" data-testid="relationship-score-value">{data.score}</div>
        <div className="text-sm" style={{ color: "var(--text-3)" }}>/ 100</div>
      </div>
      <div className="mt-3 h-2 w-full bg-[var(--border)] overflow-hidden">
        <div className="h-full" style={{ width: `${data.score}%`, background: meta.color }} />
      </div>
      {data.components && (
        <div className="mt-3 text-xs grid grid-cols-2 gap-1" style={{ color: "var(--text-3)" }} data-testid="relationship-components">
          <span>recency: {data.components.recency}</span>
          <span>frequency: {data.components.frequency}</span>
          <span>replies: {data.components.replies}</span>
          <span>meetings: {data.components.meetings}</span>
          <span>tasks: {data.components.tasks}</span>
          <span>stage: {data.components.stage}</span>
        </div>
      )}
    </div>
  );
}
